var style = {"container":"Radio-module_container__2ErqM","label":"Radio-module_label__-lh2L","checkmark":"Radio-module_checkmark__GeMc8","inner":"Radio-module_inner__XylRr"};

export { style as default };
//# sourceMappingURL=Radio.module.scss.js.map
